export function updateNotifications(state, data) {
  let count = 0
  data.forEach(element => {
    if (element.unread) {
      count++
    }
  });
  state.notifications = data
  state.unreadCount = count
}

export function markAsReadNotification(state, data) {
  for (let i = 0; i < state.notifications.length; i++) {
    if (state.notifications[i].id == data) {
      if (state.notifications[i].unread) {
        state.notifications[i].unread = false
        state.unreadCount--
      }

    }
  }
}
export function removeNotification(state, data) {
  let to_remove = -1
  let index = 0

  state.notifications.forEach(element => {
    if (element.id == data) {
      if (element.unread) {
        state.unreadCount--
      }
      to_remove = index
    }
    index++
  });

  if (to_remove != -1) {
    state.notifications.slice(to_remove, 1)
  }
}

export function removeAllNotifications(state){
  state.notifications = []
}